import { inject, Injectable, Injector, runInInjectionContext } from '@angular/core';
import { WINDOW } from '@lentau/ui-kit/core/tokens/window';
import {
  eagerEarlyActionLntCSR,
  eagerEarlyActionLntSSR,
  eagerEarlyActionUtkCSR,
  eagerEarlyActionUtkSSR,
} from '../shared/consts';
import { ActionCheck } from '../shared/interfaces';
import { PlatformService } from '@lentau/ui-kit/core/services/platform/platform.service';
import { EnvironmentBrand } from '@lentau/ui-kit/core/environments/environments.interface';
import { ENVIRONMENT_BRAND } from '@lentau/ui-kit/core/tokens/environment.brand';
import { RetailBrands } from '@lentau/ui-kit/core/tokens/constants';

@Injectable({
  providedIn: 'root',
})
export class EarlyActionService {
  private window: Window = inject(WINDOW);
  private platformService: PlatformService = inject(PlatformService);
  private injector: Injector = inject(Injector);
  private environment: EnvironmentBrand = inject(ENVIRONMENT_BRAND);

  public init(): void {
    this.requestDependsOnUrl();
  }

  private requestDependsOnUrl(): void {
    // Потенциально предварительная загрузка конструктора будет больше чем на одной странице.
    const path: string = this.window.location.pathname;

    const actions: ActionCheck[] = this.getActions();

    actions.forEach((action: ActionCheck) => {
      if (action.checkCondition.test(path)) {
        action.action(path).then((handler: () => void) => {
          runInInjectionContext(this.injector, () => {
            handler();
          });
        });
      }
    });
  }

  private getActions(): ActionCheck[] {
    const brand: RetailBrands = this.environment.BRAND;
    const isUtk: boolean = brand === RetailBrands.UTKONOS;
    const isServer: boolean = this.platformService.isServer;

    if (isUtk) {
      if (isServer) {
        return eagerEarlyActionUtkSSR;
      }
      return eagerEarlyActionUtkCSR;
    }

    if (isServer) {
      return eagerEarlyActionLntSSR;
    }
    return eagerEarlyActionLntCSR;
  }
}
